import { getSurveys } from '@/services/surveys-service/surveys-service';
import { SurveysFilters } from '@/services/surveys-service/surveys-service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';
import { OrderBy } from '../use-sort-and-pagination/use-sort-and-pagination.types';

interface SurveysFiltersProps {
  filtersParams: SurveysFilters;
  paginationParams: {
    sort_by?: string;
    order_by: OrderBy;
    page: number;
    items_per_page: number;
  };
  /** For a caller that must not ask before it knows whose surveys to ask for. */
  enabled?: boolean;
}

export const useSurveys = ({
  filtersParams,
  paginationParams,
  enabled = true,
}: SurveysFiltersProps) => {
  const {
    data: surveysData,
    error,
    isPending,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ReactQueryKeys.SURVEYS({ ...filtersParams, ...paginationParams }),
    queryFn: () => getSurveys({ ...filtersParams, ...paginationParams }),
    enabled,
  });

  // `isPending` stays true forever on a disabled query, so a caller distinguishing
  // "still arriving" from "will never arrive" needs `isLoading`.
  return { surveysData, error, isPending, isLoading, refetch };
};
